import { createElement } from 'react';
import { ClipboardListIcon } from 'lucide-react';

import { defineModule } from '@/shared/registry/types';

import { LazyFormsSection, LazySubmissionPanel } from './lazy';
import { setupWebformsRealtime } from './realtime';

/**
 * `webforms` module (docs/modules/webforms.md): web forms of the CRM — the "Web forms" section of the CRM page
 * (`/crm/forms`: the list, `/crm/forms/:id/:tab`: the builder, publishing, submissions, statistics), the side panel
 * `webform-submission:<id>` and the `webforms.submitted` notifications. The public form page `/forms/<code>` and the
 * loader `/forms/embed.js` are entries of their own (`forms.html`, `embed/embed.ts`), outside the SPA.
 */
export const module = defineModule({
  id: 'webforms',
  routes: [],
  pageSections: [
    {
      page: 'crm',
      id: 'forms',
      labelKey: 'webforms:section.title',
      icon: ClipboardListIcon,
      order: 10,
      element: () => createElement(LazyFormsSection),
    },
  ],
  sidePanels: [
    {
      type: 'webform-submission',
      component: LazySubmissionPanel,
      size: 'lg',
      titleKey: 'webforms:submission.panelTitle',
    },
  ],
  setup: setupWebformsRealtime,
});
